<script>

import axios from "axios"
// import { formatNumber, nullText } from "./utils.js"
import { product, lang, currency } from "./store.js"
// import { tns } from "./node_modules/tiny-slider/src/tiny-slider"
import LazyLoad from "vanilla-lazyload";

var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});

let amount = 1
let variation1 = ($product.variations1.length > 0 ? 0 : null)
let variation2 = ($product.variations2.length > 0 ? 0 : null)
let personification = ""
let modal = false
let finalPrice = 0

function plus(){
    amount += 1
}

function minus(){
    if(amount>1){
        amount -= 1
    }
    else{
        amount = 1
    }
}

function formatNumber(num, currency = "eur", sign = false){

    let fr = 0

    console.log(currency)

    switch (currency) {
        case "eur":
            currency = "€"
            fr = 2
            break;
        case "czk":
            currency = "Kč"
            fr = 0
            break;
    }

    if(num == null){
        return ""
    }else if(!sign){
        num = new Intl.NumberFormat('de-DE', { maximumFractionDigits: fr, minimumFractionDigits: fr }).format(num);
        return num
    }
    else{
        num = new Intl.NumberFormat('de-DE', { maximumFractionDigits: fr, minimumFractionDigits: fr }).format(num) + " " + currency;
        console.log(num)
        return num
    }
}


$: {
    console.log($currency)
    finalPrice = $product.price + ($product.variations1.length > 0 ? $product.variations1[variation1].price : 0) + ($product.variations2.length > 0 ? $product.variations2[variation2].price : 0)
}

function addToCart(){

    modal = true

    let data = {
        amount: (parseInt(amount) > 0 ? parseInt(amount) : 1),
        personification: personification,
        price: $product.price,
        product: $product.id,
        variation1: (variation1 === null ? null : $product.variations1[variation1].id),
        variation2: (variation2 === null ? null : $product.variations2[variation2].id)
    };

    axios.post('/api/cart-add',data,{withCredentials: true})

}

function continueShopping(){
    modal = false
}

</script>

<div class="mb-6">
    {#if $product.personification}
    <div class="field mb-5">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="label is-size-7 has-text-weight-normal">{($lang == "cs" ? 'Písmena monogramu nebo poznámka k objednávce' : 'Monogram letters or additional request')}</label>
        <div class="control">
            <input class="input" type="text" bind:value={personification}>
        </div>
    </div>
    {/if}

    {#if $product.variations1 && $product.variations1.length > 0}
    <div class="field mb-5">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="label is-size-7 has-text-weight-normal">{$product.variations1_text}</label>

        <div class="control">
            <div class="select">
            <select bind:value={variation1} style="min-width:130px">
                {#if $product.variations1}
                {#each $product.variations1 as v, i}
                <option value="{i}">{v.title} {(v.price > 0 ? '(+ ' + formatNumber(v.price, $currency, true) + ')' : '')}</option>
                {/each}
                {/if}
            </select>
            </div>
        </div>
    </div>
    {/if}

    {#if $product.variations2 && $product.variations2.length > 0}
    <div class="field mb-5">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="label is-size-7 has-text-weight-normal">{$product.variations2_text}</label>

        <div class="control">
            <div class="select">
            <select bind:value={variation2} style="min-width:130px">
                {#if $product.variations2}
                {#each $product.variations2 as v, i}
                <option value="{i}">{v.title} {(v.price > 0 ? '(+ ' + formatNumber(v.price, $currency, true) + ')' : '')}</option>
                {/each}
                {/if}
            </select>
            </div>
        </div>
    </div>
    {/if}

    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label class="label is-size-7 has-text-weight-normal">{($lang == "cs" ? 'Množství' : 'Quantity')}</label>
    <div class="field is-grouped">

        <div class="control has-icons-left has-icons-right" style="width:130px">
            <input class="input has-text-centered" type="text" bind:value={amount}>
            <span class="icon is-small is-left is-clickable" on:click={minus}>
                <img src="/img/icons/minus-circle.svg" class="image is-16x16" alt="-">
            </span>
            <span class="icon is-small is-right is-clickable" on:click={plus}>
                <img src="/img/icons/plus-circle.svg" class="image is-16x16" alt="+">
            </span>
        </div>
        <button class="button is-belle-full" on:click={addToCart}>{($lang == "cs" ? 'Vložit do košíku' : 'Add to cart')}</button>
    </div>
</div>

{#if modal}
<div class="modal is-active">
    <div class="modal-background" on:click={continueShopping}></div>
    <div class="modal-content">
        <div class="box">
            <div class="block is-size-4">
                <span class="icon mr-2">
                    <img src="/img/icons/check-circle.svg" class="image is-24x24" style="transform: translateY(4px);" alt="OK">
                </span>
                {($lang == "cs" ? 'Produkt byl přidán do košíku' : 'We just added this to your cart')}

            </div>
            <article class="media block">
                <div class="media-left">
                <figure class="image is-128x128" style="width:100px;height:100px">
                    {#if $product}
                    <picture>
                        <source type="image/webp" srcset="/img/p/440-{ $product.img }.webp">
                        <source type="image/jpeg" srcset="/img/p/440-{ $product.img }.jpg">
                        <img src="/img/p/440-{ $product.img }.jpg" alt="{ $product.title }">
                    </picture>
                    <!-- <img src="/img/p/440-" alt="img"
                            srcset="
                                /img/p/440-{ $product.img } 440w,
                                /img/p/880-{ $product.img } 880w"
                            loading="lazy"
                            > -->
                    <!-- <img src="/img/p/460-{ $product.img }" alt="{ $product.title }"> -->
                    {/if}
                </figure>
                </div>
                <div class="media-content">
                    <p class="has-text-weight-bold mb-1">
                        { $product.title }
                    </p>
                    {#if variation1 !== null}
                    <p class="mb-1">
                        {($lang == "cs" ? 'variace' : 'variation')}: { $product.variations1[variation1].title }{#if variation2 !== null}, { $product.variations2[variation2].title }{/if}
                    </p>
                    {/if}
                    {#if personification}
                    <p class="">
                        <span class="has-text-grey">{($lang == "cs" ? 'personifikace' : 'personification')}:</span> { personification }
                    </p>
                    {/if}
                    <p class="mb-1">
                        <span class="has-text-grey">{($lang == "cs" ? 'cena' : 'price')}:</span> { formatNumber(finalPrice, $currency, true) }
                    </p>
                    <p class="mb-1">
                        <span class="has-text-grey">{($lang == "cs" ? 'kusů' : 'pieces')}:</span> { amount }
                    </p>
                </div>
            </article>

            <div class="level mx-auto is-mobile">
                <div class="level-left">
                    <a href="/" class="is-underlined" on:click|preventDefault={continueShopping}>{($lang == "cs" ? 'Pokračovat v nákupu' : 'Continue shopping')}</a>
                </div>
                <div class="level-right">
                    <a href="/{$lang}/{($lang == "cs" ? 'kosik' : 'cart')}" class="button is-belle-full">{($lang == "cs" ? 'Jdi do košíku' : 'Go to cart')}</a>
                </div>
            </div>
        </div>
    </div>
    <button class="modal-close is-large" aria-label="close" on:click={continueShopping}></button>
</div>
{/if}
